import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class FormCostItem {
  @bindable private costitem: any;

}
